import { json } from "@sveltejs/kit";
import { t as taskManager } from "../../../../../chunks/task-manager.js";
const POST = async ({ request }) => {
  try {
    const { pid } = await request.json();
    if (!pid) {
      return json({ error: "Process ID is required" }, { status: 400 });
    }
    taskManager.stopTask(pid);
    return json({ success: true });
  } catch (error) {
    console.error("Failed to stop task:", error);
    return json({ error: error.message }, { status: 500 });
  }
};
export {
  POST
};
